const ReadersWriterLock = require("./src/readers-writer-lock.cjs")

module.exports = {
  ReadersWriterLock
}
